/*
  mezuzi, theme 175.0 (#133, Head 80.0) - the recommendations carousel arrows' hover = the source's.

  The source's arrow is `button.button--secondary` [is=previous-button|next-button] with a `.btn-fill`: a brown ellipse
  (inset -28px -14px, 84x112) that rises from below on pointer enter (76% -> 0) and continues up on leave (-> -76%),
  600 ms ease; the icon turns white (CSS). A DISABLED arrow gets no fill; keyboard focus gets no fill (source read 13.10:
  review-175/s7/src-fill.txt). The source ignores prefers-reduced-motion; ours follows Elad 10.10 Q1 "ב" - the end
  state at once.

  The fill code below is a COPY of the same binder in assets/cart-close-hover.js (#99) and of hoverFill() in
  snippets/header-drawer.liquid (the menu drawer's Login + close, #85b) - change one, change the others (a shared
  binder is a later tool step, LIST-ADD-175 #134). Our arrows come from Tinker's slideshow-arrow snippet, so the fill
  span is inserted here, on the first pointerover, and the white icon is ARMED by `data-reci-fill` (set when a fill starts): if this
  file does not run, the hover keeps the brown icon on a white button (Head 80.0, the #110 / #120 lesson).
*/

const BUTTON = "[id$='__recommendations_inova'] .resource-list__carousel > slideshow-container > slideshow-arrows .slideshow-control";
const ENTER_FROM = 'translate3d(0, 76%, 0)';
const REST = 'translate3d(0, 0, 0)';
const LEAVE_TO = 'translate3d(0, -76%, 0)';

/**
 * The fill span, looked up - and put back - at each event (a re-render may drop it while keeping the button node);
 * the listeners are bound once per node by a JS property (the cart-close morph lesson).
 * @param {HTMLElement} button
 */
function fillOf(button) {
  let fill = button.querySelector(':scope > .reci__arrow-fill');
  if (!fill) {
    fill = document.createElement('span');
    fill.className = 'reci__arrow-fill';
    fill.setAttribute('aria-hidden', 'true');
    button.prepend(fill);
  }
  return /** @type {HTMLElement} */ (fill);
}

/** @param {HTMLElement} button */
function bind(button) {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  /** @param {string | null} from @param {string} to */
  const go = (from, to) => {
    const fill = fillOf(button);
    const start = from || getComputedStyle(fill).transform;
    for (const animation of fill.getAnimations()) animation.cancel();
    fill.animate([{ transform: start }, { transform: to }], { duration: reduced.matches ? 0 : 600, easing: 'ease', fill: 'forwards' });
  };
  button.addEventListener('pointerenter', (event) => {
    if (event.pointerType !== 'touch' && !button.disabled) {
      go(ENTER_FROM, REST);
      // armed only once a real fill is rising - never at bind (Head 80.0, option C): the white icon cannot appear without it
      button.setAttribute('data-reci-fill', '');
    }
  });
  button.addEventListener('pointerleave', (event) => {
    // only a fill that exists leaves (a disabled arrow that was never filled made a hidden span + an animation - review-175/s7/ka-c.txt)
    if (event.pointerType !== 'touch' && button.querySelector(':scope > .reci__arrow-fill')) go(null, LEAVE_TO);
  });
}

document.addEventListener('pointerover', (event) => {
  const button = event.target instanceof Element ? /** @type {HTMLElement | null} */ (event.target.closest(BUTTON)) : null;
  if (!button || /** @type {any} */ (button).__reciArrowHover || !window.matchMedia('(any-hover: hover)').matches) return;
  /** @type {any} */ (button).__reciArrowHover = true;
  bind(button);
  // Pointer coming from OUTSIDE: the real pointerenter follows this pointerover (spec order) and reaches the listener just bound - a
  // synthetic one made 2 fills on the first hover (Head 80.0 (a), review-175/s7/first-enter.txt). Pointer ALREADY INSIDE (this module
  // loads late, the pointer may rest on the arrow; this pointerover comes from a move between the button's children): no real
  // pointerenter will come, and the armed :hover would turn the icon white over no fill - so start the fill here (Head 80.0).
  const inside = event.relatedTarget instanceof Node && button.contains(event.relatedTarget);
  if (inside && event.pointerType !== 'touch' && !button.disabled) button.dispatchEvent(new PointerEvent('pointerenter', { pointerType: event.pointerType }));
});
